import React from 'react';
import { useLanguage } from '../helpers/i18n';

const Loading = ({ prompt: name = 'page' }) => {
  const { t } = useLanguage();
  const message = !name || name === 'page'
    ? t('common.loading')
    : t('common.loadingNamed').replace('{name}', name);

  return (
    <div className='app-loading' role='status' aria-live='polite'>
      <span className='app-loading-spinner' />
      <span>{message}</span>
    </div>
  );
};

export default Loading;
